export default {
  en: 'en',
  bg: 'bg'
};
